<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
  },
  methods:{}
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
html, body {
  height: 100%;
  font-size: 16px;
}
u {
  cursor: pointer;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-family: Roboto;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  height: 100%;
}
/* css for current location bar */
.current-location {
  height: 56px;
  min-width:1361px;
  background-color: #e6e6e6;
  padding-right: 24px;
}
.current-location-bottom{
  height: 1px;
  min-width:1280px;
  background-color: #c8c8c8;
}
.location-content{
  text-align: left;
  font-size: 12px;
  color: #323233;
  line-height:56px;
  float: left;
  margin-left:1.9%;
  font-family: Roboto;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/App.vue